import {Injectable} from '@angular/core';
import {AbstractSessionParametersLoaderService} from "../abstract-session-parameters-loader.service";
import {StandingParameters} from "./standing-parameters";

@Injectable({
    providedIn: 'root'
})
export class StandingParametersLoaderService extends AbstractSessionParametersLoaderService<StandingParameters> {

    constructor() {
        super('standing');
    }
}
